import { render } from "./review-upload-modal.vue?vue&type=template&id=76cb5fa5&ts=true"
import script from "./review-upload-modal.ts?vue&type=script&lang=ts&external"
export * from "./review-upload-modal.ts?vue&type=script&lang=ts&external"

import "./review-upload-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__